export default class GalleryThumbnail {
    constructor(url, variantId) {
        this.originalUrl = url;
        this.variantId = variantId;

        let youTubeVideoID = this.getYoutubeHash(url);

        if (youTubeVideoID) {
            this.src = 'https://img.youtube.com/vi/' + youTubeVideoID + '/0.jpg';
        } else {
            this.src = url.replace(/-[0-9]{3,4}x[0-9]{3,4}-/gm, '-150x113-');
        }
    }

    getYoutubeHash(url) {
        let regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
        let match = url.match(regExp);

        if (match && match[7].length == 11) {
            return match[7];
        }

        let imageCheck = /img.youtube.com\/vi\/(.*?)\//;
        match = url.match(imageCheck);

        if (match && match[1].length == 11) {
            return match[1];
        }

        return false;
    }
}
